module.exports = __webpack_public_path__ + "img/data_storage_flatline.e9b7bee7.svg";